import { FuseNavigationItem } from '@fuse/components/navigation';

export const navigationItems: FuseNavigationItem[] = [
    {
        id: 'main',
        title: 'Main',
        type: 'group',
        children: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                type: 'basic',
                icon: 'dashboard',
                link: '/dashboard',
            },
            {
                id: 'Purchasing',
                title: 'Purchasing',
                type: 'collapsable',
                icon: 'mat_outline:storefront',
                children: [
                    {
                        id: 'purchase-leads',
                        title: 'Purchase Leads',
                        type: 'basic',
                        icon: 'mat_outline:how_to_reg',
                        link: '/purchase-lead',
                        meta: { permission: 'Customer:Read' },
                    },
                    {
                        id: 'Sellers',
                        title: 'Sellers',
                        type: 'basic',
                        icon: 'mat_outline:store',
                        link: '/seller',
                        meta: { permission: 'Customer:Read' },
                    },
                    {
                        id: 'finders',
                        title: 'Finders',
                        type: 'basic',
                        icon: 'mat_outline:campaign',
                        link: '/finder',
                        meta: { permission: 'Finder:Read' },
                    },
                ],
            },
            {
                id: 'Inventory',
                title: 'Inventory',
                type: 'collapsable',
                icon: 'heroicons_outline:calendar-days',
                children: [
                    {
                        id: 'cuurent-inventory',
                        title: 'Current Inventory',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar-days',
                        link: '/current-inventory',
                        meta: { permission: 'Inventory:Read' },
                    },
                    {
                        id: 'all-inventory',
                        title: 'All Inventory',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar-days',
                        link: '/inventory',
                        meta: { permission: 'Inventory:Read' },
                    },
                ],
            },
            {
                id: 'inspection',
                title: 'Inspections',
                icon: 'custom:inspection',
                type: 'basic',
                link: '/inspection',
                meta: { permission: 'Inspection:Read' },
            },
            {
                id: 'Customer',
                title: 'Customer',
                type: 'collapsable',
                icon: 'mat_outline:shopping_cart',
                children: [
                    {
                        id: 'Leads',
                        title: 'Manage Leads',
                        type: 'basic',
                        icon: 'mat_outline:person_add',
                        link: '/lead',
                        meta: { permission: 'Customer:Read' },
                    },
                    {
                        id: 'All Customers',
                        title: 'All Customers',
                        type: 'basic',
                        icon: 'mat_outline:people',
                        link: '/customer',
                        meta: { permission: 'Customer:Read' },
                    },
                ],
            },

            {
                id: 'sales',
                title: 'Sales',
                type: 'collapsable',
                icon: 'heroicons_outline:chart-pie',
                children: [
                    {
                        id: 'sales-overview',
                        title: 'Historical Sales',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-bar',
                        link: '/sales',
                        meta: { permission: 'Inventory:Read' },
                    },
                    {
                        id: 'sales-map',
                        title: 'Map View',
                        type: 'basic',
                        icon: 'heroicons_outline:map',
                        link: '/map-view',
                        meta: { permission: 'Inventory:Read' },
                    },
                ],
            },
            {
                id: 'documents',
                title: 'Documents',
                type: 'collapsable',
                icon: 'heroicons_outline:document-text',
                children: [
                    {
                        id: 'documents',
                        title: 'Documents',
                        type: 'basic',
                        icon: 'heroicons_outline:document',
                        link: '/documents',
                        meta: { permission: 'CustomerDocument:Read' },
                    },
                    {
                        id: 'document_template',
                        title: 'Templates',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/document-template',
                        meta: { permission: 'DocumentTemplate:Read' },
                    },
                ],
            },
            {
                id: 'bookmarks',
                title: 'Bookmarks',
                type: 'basic',
                icon: 'heroicons_outline:bookmark',
                link: '/bookmarks',
                meta: { permission: 'BookmarkLink:Read' },
            },
        ],
    },
    {
        id: 'others',
        title: 'Others',
        type: 'group',
        children: [
            {
                id: 'users',
                title: 'Users',
                type: 'collapsable',
                icon: 'heroicons_outline:users',
                children: [
                    {
                        id: 'users-managemenet',
                        title: 'Manage Users',
                        type: 'basic',
                        link: '/users',
                        icon: 'heroicons_outline:user-plus',
                        meta: { permission: 'User:Read' },
                    },
                    {
                        id: 'permission',
                        title: 'Roles & Permissions',
                        type: 'basic',
                        icon: 'mat_solid:lock_open',
                        link: '/permission',
                        meta: { permission: 'User:RolePermission' },
                    },
                    {
                        id: 'designation',
                        title: 'Designations',
                        type: 'basic',
                        icon: 'heroicons_outline:identification',
                        link: '/designation',
                        meta: { permission: 'User:Designation' },
                    },
                ],
            },
            {
                id: 'resources',
                title: 'Resources',
                type: 'collapsable',
                icon: 'heroicons_outline:swatch',
                children: [
                    {
                        id: 'customer-source',
                        title: 'Customer Sources',
                        type: 'basic',
                        icon: 'heroicons_outline:newspaper',
                        link: '/customer-source',
                        meta: { permission: 'Customer:Source' },
                    },
                    {
                        id: 'inventory-source',
                        title: 'Inventory Sources',
                        type: 'basic',
                        icon: 'heroicons_outline:newspaper',
                        link: '/inventory-source',
                        meta: { permission: 'Inventory:Source' },
                    },
                    {
                        id: 'vehicle-make',
                        title: 'Make',
                        type: 'basic',
                        link: '/vehicle-make',
                        icon: 'heroicons_mini:wrench',
                        meta: { permission: 'Inventory:Make' },
                    },
                    {
                        id: 'vehicle-model',
                        title: 'Model',
                        type: 'basic',
                        link: '/vehicle-model',
                        icon: 'heroicons_outline:tag',
                        meta: { permission: 'Inventory:Model' },
                    },
                    {
                        id: 'document-category',
                        title: 'Document Category',
                        type: 'basic',
                        link: '/document-category',
                        icon: 'mat_outline:category',
                        meta: { permission: 'DocumentTemplate:Category' },
                    },
                ],
            },
            {
                id: 'settings',
                title: 'Settings',
                type: 'basic',
                icon: 'settings',
                link: '/settings',
            },
            {
                id: 'template',
                title: 'Email Templates',
                type: 'basic',
                icon: 'email',
                link: '/template',
                meta: { permission: 'Template:Read' },
            },
            {
                id: 'cms-page-management',
                title: 'CMS Pages',
                type: 'basic',
                icon: 'pages',
                link: '/cms-page-management',
                meta: { permission: 'Page:Read' },
            },
        ],
    },
];
